import { ForexHistoryItem, ForexStatus } from '@/feature/TrHistory/api/forex-history.interface';
import { ForexOperationType } from '@/feature/TrHistory/api/forex.interface';

export enum ForexCurrency {
	USD = '840',
	EUR = '978',
	RUB = '643',
	GBP = '826',
	JPY = '392',
	KZT = '398',
	CNY = '156',
}

export interface ForexHistoryState {
	list: ForexHistoryItem[]
	loadingCount: number
	pageSize: number
	pageNumber: number
	isEndPage: boolean
	fromOperDay: string // YYYY-MM-DD
	toOperDay: string // YYYY-MM-DD
	id: number | null
	fromRequestAmount: number | null
	toRequestAmount: number | null
	status: ForexStatus | null
	type: ForexOperationType | null
	currency: ForexCurrency | null
}
